<template>
<b-container class="laneclosure-add-container" v-if="batch != null && loaded">
	<b-row>
		<b-col size="10">
			<h2 class="title is-4">{{ batch.batchNotes }}</h2>
			<p>User: {{ batch.userName }}</p>
			<p>Log Date: {{ formatTime(batch.date) }}</p>
		</b-col>
		<b-col>
			<b-button label="Back" style="float: right" colour="light" @click="goToAuditList()" />
		</b-col>
	</b-row>
<b-row>
	<b-col>
		<b-card v-for="(log, key) in logs" :key="key">
			<template slot="header">
				{{ log.logNotes }}
			</template>

			<ul v-if="log.changes">
				<li v-for="(change,name) in log.changes" :key="name">
					<template v-if="change[0] == null"> <!-- Or just say changed from null to something? -->
						Added <b>{{ name }}</b> with the value of <b>{{ formatValue(change[1], name) }}</b>
					</template>
					<template v-else-if="change[1] == null">
						Deleted <b>{{ name }}</b> that had the value <b>{{ formatValue(change[0], name) }}</b>
					</template>
					<template v-else>
						<b>{{ name }}</b> changed from <b>{{ formatValue(change[0], name) }}</b> to <b>{{ formatValue(change[1], name) }}</b>
					</template>
				</li>
			</ul>

			<ul v-else-if="log.newValues && 1 == 2">
				<li v-bind:key="`logOldValues`+name+Math.random()" v-for="(value,name) in log.newValues">{{ name }}: {{ formatValue(value, name) }}</li>
			</ul>

			<ul v-else-if="log.oldValues && 1 == 2">
				<li v-bind:key="`logOldValues`+name+Math.random()" v-for="(value,name) in log.oldValues">{{ name }}: {{ formatValue(value, name) }}</li>
			</ul>


		</b-card>
	</b-col>
	</b-row>

</b-container>
</template>


<script>
import Organization from '../../../models/Organization';
import ErrorHandler from '../../../utility/ErrorHandler';

import Format from '../../../utility/Format';
import Vue from 'vue'

export default {
  name: 'AddOrganization',

  components: {

  },

  data() {
	return {
		Organization,
		Format,
		form: null,
		loaded:false,
		parentOrganization:{id:-1,name:"Primary Organization", parentId:null},
		organizations: [],
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		showRequiredFieldModal: false,
		show: true,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
	}
	},
	mounted() {
		this.LoadData(this.$route.params.id);
		this.$nextTick(() => {
		})
   },
	computed: {
	},

	watch: {
	},
  methods: {
	getIsApprovedText(val) {
		if (val) {
			return Organization.getIsApprovedText(val);
		}
		return null;
	},
	getIsActiveText(val) {
		if (val) {
			return Organization.getIsActiveText(val);
		}
		return null;
	},
	hasParentId() {
		if (this.form.parentId != null) {
			if (this.form.parentId.value != null) {
				if (this.form.parentId.value.id != null && this.form.parentId.value.id != -1) {
					return true;
				}
			}
		}
		return false;
	},
	canSetApproval() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			if (this.form) {
				if (this.form.parentId) {
					if (this.form.parentId.value) {
						if (this.form.parentId.value.id == -1 || this.form.parentId.value.id == null) {
							return true;
						}
					} else {
						return true;
					}
				}
			}
		}
		return false;
	},
	canSetActive() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		}
		return false;
	},
	canEditComments	() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		}
		return false;
	},

	canEditOrganization() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		} else {
			if (this.$store.getters.userHasRole('agency_admin')) {
				// verify that the user's organization ID is in the list of organizations...
				return this.$store.getters.canEditUserInOrganization(this.form.id, this.organizations);
			}
		}
		return false;
	},
	toggleIsApproved(item) {
		if (this.form.isApproved.value == 1) {
			this.form.isApproved.value = 0;
		} else {
			this.form.isApproved.value = 1;
		}
	},
	setParentIdFromSelection(val) {
		let x = 0;
		for (x = 0; x < this.organizations.length; x++) {
			if (val == this.organizations[x].id) {
				this.parentOrganization = this.organizations[x];
			}
		}
	},

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	getFlatTree(option) {
		if (option) {
			if (option.namePath) {
				return Format.pipesToFlatTree(option.namePath);
			} else {
				return option.name;
			}
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

	getLevelClassName(level) {
		return "level-"+level;
	},
		GetOrganizations() {
			this.$store.dispatch('organizationList/loadEditable', {keywords:null})
						.then(() => {
								this.organizations = [];
								let records = this.$store.getters['organizationList/getRecords'];
								if ( records ) {
						this.organizations.push({id:-1,name:"This is the Primary Organization", parentId:null});
									records.forEach( item => {
										this.organizations.push(item);
							if (item.id == this.form.parentId.value) {
								this.form.parentId.value = item;
							}
							this.loaded = true;
									})
								}
								if (this.form.parentId.value == null) {
									this.form.parentId.value = this.organizations[0];
								}
							})
						.catch( error => console.log('error', error) ); // eslint-disable-line
		},

			LoadData(id = this.id) {
				this.loaded = false;
				// Remove any messages being displayed.
				this.submissionStatus = null;
				// this.form = new Organization();
				// this.form.parentId = null;
				if (id && Format.TryParseInt(id) > 0) {
					this.GetData(id);
				}
			},


			GetData(id) {

				if (Format.TryParseInt(id)) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/organization/" + id + "/edit?r=" + Math.round(Math.random() * Math.pow(10, 6)))
					.then(response => {
						this.form = new Organization(response.data);
						// this.$store.commit('formId', response.data.Id);
						this.loaded = true;
						this.$nextTick(() => {
							this.GetOrganizations();
							this.setParentIdFromSelection(this.form.parentId.value);
						})


					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							if (error.response && error.response.data) {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							ErrorHandler.RedirectToLogin();
						}
					});
				}

			},


	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			Vue.prototype.$bus.$emit("map:toggle", 0);
	});
	},
}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>








